<template>
  <div>
    <h3 class="modal-title"> WIDGET </h3>

    <b-form-group :class="{'error-input' : $v.data_widget.title.$error}">
      <label> Widget Title </label>
      <j-input
        v-model="$v.data_widget.title.$model"
        :max-length="255"
        placeholder="Widget Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_widget.widget.$error}">
      <label> Select Widget </label>
      <j-single-select
        v-model="$v.data_widget.widget.$model"
        :options="list_widget"
        :placeholder="`Choose Widget`"
        label="name"
        value-format="object"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeWidget">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveWidget">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_widget: {
      title: {
        required,
      },
      widget: {
        required,
      },
    },
  },
  data() {
    return {
      data_widget: {
        title: '',
        widget: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_widget']),

    generateDataWidget() {
      const data = {
        value_id: `${this.data_widget.widget.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_widget.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          id: this.data_widget.widget.id,
        }),
        type_platform: 1,
      };
      return data;
    },

    generateDataWidgetUpdate() {
      const data = {
        value_id: `${this.data_widget.widget.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_widget.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          id: this.data_widget.widget.id,
        }),
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    const parameter = {
      limit: 10,
      page: 1,
      column: 'id',
      sort: 'asc',
    };
    this.getListWidget({ params: parameter });

    if (this.modeEdit) {
      this.data_widget.widget = {
        id: JSON.parse(this.dataEdit.info).id,
        name: JSON.parse(this.dataEdit.info).name,
      };
      this.data_widget.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getListWidget']),

    saveWidget() {
      this.$v.data_widget.$touch();
      if (!this.$v.data_widget.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataWidget,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataWidgetUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeWidget();
      }
    },

    closeWidget() {
      this.$emit('close-field');
      this.data_widget.title = '';
      this.data_widget.widget = null;
      setTimeout(() => {
        this.$v.data_widget.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jWidgetSetup.vue